import {
	updatePageItem as _updatePageItem,
	updatePageItems as _updatePageItems,
} from "../redux/actions/PageItemActions";
import { getPageItemIdsFromQuery } from "../utils/PageItemsUtils";

export function updatePageItem(query, updates) {
	if (typeof query === "string") {
		return _updatePageItem(query, updates);
	} else {
		const ids = getPageItemIdsFromQuery(query, this);
		return _updatePageItems(
			ids.map((id) => {
				const obj = Object.assign({}, updates);
				obj.id = id;
				return obj;
			})
		);
	}
}

export function updatePageItems(ids, updates) {
	return updatePageItem(ids, updates);
}
